import * as React from 'react';

const SvgDocumentOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M8 7h3v2H8V7ZM16 11H8v2h8v-2ZM8 15h8v2H8v-2Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m15 2 5 5v15H4V2h11Zm0 5h2.17L15 4.83V7ZM6 20h12V9h-5V4H6v16Z", fill: "currentColor" })));

export { SvgDocumentOutline as default };
